import { useAppSelector } from 'flow/hooks/useRedux';
import { QueueKey } from 'flow/types/EntityKeys';
import { selectQueueHasOmniSupport } from 'flow/selectors/queue-selectors';
import useAppContext from 'flow/hooks/useAppContext';
import SectionTitle from '../../SectionTitle';

interface Props {
    queueKey: QueueKey;
}

const TitleWaitingQueueItems = ({ queueKey }: Props) => {
    const { i18next } = useAppContext();

    const queueHasOmniSupport = useAppSelector((state) =>
        selectQueueHasOmniSupport(state, queueKey),
    );

    return (
        <SectionTitle>
            {queueHasOmniSupport
                ? i18next.t('Queue.InQueue.Section.Title')
                : i18next.t('Queue.CallsInQueue.Section.Title')}
        </SectionTitle>
    );
};

export default TitleWaitingQueueItems;
